import { LocalTime } from "@js-joda/core";
import dayjs from "dayjs";
import type { Dayjs } from "dayjs";

export const localTimeToDayJs = (time: LocalTime): Dayjs => dayjs(`1970-01-01T${time.toString()}`);
export const dayJsToLocalTime = (time: Dayjs): LocalTime =>
    LocalTime.of(time.hour(), time.minute(), time.second());
